import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components';
var ExpiredModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExpiredModalComponent, _super);
    function ExpiredModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExpiredModalComponent;
}(UiModalComponent));
export { ExpiredModalComponent };
